import * as React from "react";
export function SvgSpacesMediumFile(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={24} {...props}>
      <path
        d="M18 7l-4-4H6c-.5 0-1 .5-1 1v15c0 .5.5 1 1 1h11c.5 0 1-.5 1-1V7zm-4-2.4L16.4 7H14V4.6zM17 19H6V4h7v4h4v11z"
        fill="#676767"
      />
    </svg>
  );
}
